import { render, staticRenderFns } from "./split-view.vue?vue&type=template&id=3de1a31e&"
import script from "./split-view.vue?vue&type=script&lang=js&"
export * from "./split-view.vue?vue&type=script&lang=js&"
import style0 from "./split-view.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports